// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1wdGr","footer":"ChangeClinic_footer__2aC6C"};